import { useMemo } from 'react'

import {
  F0Box,
  SurveyFormBuilder,
  SurveyFormBuilderElement,
  QuestionType,
} from '@factorialco/f0-react'

import {
  FromFormToQuestionnaire,
  FromQuestionnaireToForm,
} from 'modules/forms/components/newFormEditor/helpers'
import { QuestionnaireType } from 'modules/forms/components/newFormEditor/types'

const ALLOWED_QUESTION_TYPES: QuestionType[] = [
  'text',
  'longText',
  'select',
  'multi-select',
  'numeric',
  'link',
  'date',
  'dropdown-single',
]

interface Props {
  state: QuestionnaireType
  setState: (state: QuestionnaireType) => void
}

const NewFormEditor = ({ state, setState }: Props) => {
  const elements = useMemo(
    () =>
      FromQuestionnaireToForm(state.elements, {
        mapDropdownSingleTo: 'dropdown-single',
      }),
    [state.elements]
  )

  const handleChange = (updatedElements: SurveyFormBuilderElement[]) => {
    setState({ ...state, elements: FromFormToQuestionnaire(updatedElements) })
  }

  return (
     <F0Box width="full" height="full" padding="md" paddingBottom="5xl">
      <SurveyFormBuilder
        elements={elements}
        onChange={handleChange}
        allowedQuestionTypes={ALLOWED_QUESTION_TYPES}
      />
    </F0Box>
  )
}

export default NewFormEditor
